import { selector } from "recoil";

import { BookingsPollingStatusEnum } from "../../../enums";
import { Log } from "../../../helpers/log.helpers";
import {
  defaultBookingBulkCreateState,
  IBookingsPollingUiState,
} from "../../../models";
import { bookingsPollingStateAtom } from "../../atoms";
import { resolvePollingState } from "./bookings-polling.recoil-utils";

export const isBulkBookingSetAbortedSelector = selector<boolean>({
  key: "isBulkBookingSetAbortedSelector",
  get: ({ get }) => {
    const pollingState = get(bookingsPollingStateAtom);

    if (!pollingState) {
      return false;
    }

    const { status, isAborted } = pollingState;

    return isAborted || status === BookingsPollingStatusEnum.Aborted;
  },
});

export const isBulkBookingSetFinishSelector = selector<boolean>({
  key: "isBulkBookingSetFinish",
  get: ({ get }) => {
    const pollingState = get(bookingsPollingStateAtom);

    if (!pollingState) {
      return false;
    }

    const { status, isPreview } = pollingState;

    return !isPreview && status === BookingsPollingStatusEnum.Completed;
  },
});

export const isBulkBookingValidationFinishSelector = selector<boolean>({
  key: "isBulkBookingValidationFinishSelector",
  get: ({ get }) => {
    const pollingState = get(bookingsPollingStateAtom);

    if (!pollingState) {
      return false;
    }

    const { status, isPreview } = pollingState || {};

    return Boolean(isPreview && status === BookingsPollingStatusEnum.Completed);
  },
});

export const bookingBulkCreateStateFromPollingState =
  selector<IBookingsPollingUiState>({
    key: "bookingBulkCreateStateFromPollingState",
    get: ({ get }) => {
      const bookingsPollingState = get(bookingsPollingStateAtom);

      if (
        !bookingsPollingState ||
        bookingsPollingState.status === BookingsPollingStatusEnum.Idle
      ) {
        Log.debug("Polling state set to DEFAULT");
        return defaultBookingBulkCreateState;
      }

      return resolvePollingState(bookingsPollingState);
    },
  });
